import 'bootstrap';
import * as Turbo from '@hotwired/turbo'
import './batch_actions.js'
Turbo.start()
